import React from 'react';
import { Box, Typography } from '@mui/material';
import { DS } from './designTokens';

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, children }) => (
  <Box
    sx={{
      background: DS.surfaceRaised,
      borderRadius: '20px',
      boxShadow: DS.shadowSm,
      px: '20px',
      py: '16px',
    }}
  >
    <Typography
      component="h2"
      sx={{
        display: 'inline-block',
        backgroundColor: DS.coolMint,
        color: DS.deepTeal,
        fontSize: '12px',
        fontWeight: 900,
        fontFamily: DS.fontBody,
        px: 1.5,
        py: 0.5,
        borderRadius: '6px',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        mb: 1.5,
      }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        fontSize: '14px',
        fontWeight: 400,
        color: DS.softBlack,
        lineHeight: 1.65,
        fontFamily: DS.fontBody,
        '& p': { m: 0, mb: 0.5 },
      }}
    >
      {children}
    </Box>
  </Box>
);

export default SectionCard;
